import { Directive, ElementRef, Renderer2, HostListener, Input, OnInit } from '@angular/core';
import {ProductsService} from '../services/products.service';

@Directive({
  selector: '[appEditcartingredient]'
})
export class EditcartingredientDirective {
  isChecked:string;
  prodIdAr:any[] = [];
  storedCart = [];
  ingArr = [];
  ingridentArray:any[] = [];
  constructor(private renderer:Renderer2, private el:ElementRef, private prodObj:ProductsService) { }

  @HostListener('click') onClick() {
    this.isChecked = this.el.nativeElement.getAttribute('ischecked');

    if (this.isChecked == 'no'){
      this.renderer.setAttribute(this.el.nativeElement, 'ischecked', 'yes');
    }else{
      this.ingridentArray['pid'] = this.el.nativeElement.getAttribute('pid');
      this.ingridentArray['gradeName'] = this.el.nativeElement.getAttribute('gradeName');
      this.ingridentArray['gradeid'] = this.el.nativeElement.getAttribute('gradeid');
      this.ingridentArray['ingvalue'] = this.el.nativeElement.getAttribute('value');

      this.prodObj.ingrdAr.emit(this.ingridentArray); //Emmiting id array to products service and then receiving in product detail component

      this.renderer.setProperty(this.el.nativeElement, 'checked', false);
      this.renderer.setAttribute(this.el.nativeElement, 'ischecked', 'no');
    }
  }

  ngOnInit(){
    var gradeName = this.el.nativeElement.getAttribute('gradeName');
    var gradeId = this.el.nativeElement.getAttribute('gradeid');
    var productId = this.el.nativeElement.getAttribute('pid');
    var slectedVal = this.el.nativeElement.value;
    let gradientArray = {
      'ingName': gradeName,
      'ing_id': gradeId,
      'product_id': productId,
      'selectedvalue': slectedVal
    }
  
    this.storedCart = JSON.parse(localStorage.getItem("cartData"));
    if(this.storedCart != null && this.storedCart.length > 0){
      for(var c=0; c < this.storedCart.length; c++){
        if(this.storedCart[c].pId == productId){
            if(this.storedCart[c].ingradients.length > 0){
              for(var d=0; d < this.storedCart[c].ingradients.length; d++){
               if(this.storedCart[c].ingradients[d].ing_id == gradeId && this.storedCart[c].ingradients[d].selectedvalue == slectedVal){
                  
                this.ingArr['ingName'] = gradeName;
                this.ingArr['ing_id'] = gradeId;
                this.ingArr['product_id'] = productId;
                this.ingArr['selectedvalue'] = slectedVal;
               
                this.renderer.setProperty(this.el.nativeElement, 'checked', true);
                this.renderer.setAttribute(this.el.nativeElement, 'ischecked', 'yes');
                this.prodObj.ingcartArr.emit(this.ingArr);     

               }
              }
            }
        }
      }
      
    }
  }
}
